export default {
  createAnAccount: 'Завести аккаунт',
  createNewAccount: 'создайте новый аккаунт',
  forgotYourPasswordQuestion: 'Забыли ваш пароль?',
  signIn: 'Войти',
  signUp: 'Зарегистрироваться',
  signInToYourAccount: 'войдите в свой аккаунт'
};
